export enum LanguageName {
  af = 'Afrikaans',
  sq = 'âªShqipâ¬',
  ar = 'Ø§ÙØ¹Ø±Ø¨ÙØ©',
  hy = 'âªÕ°Õ¡ÕµÕ¥ÖÕ¥Õ¶â¬',
  az = 'âªAzÉrbaycanâ¬',
  eu = 'âªEuskaraâ¬',
  be = 'ÐÐµÐ»Ð°ÑÑÑÐºÐ°Ñ Ð¼Ð¾Ð²Ð°',
  bn = 'à¦¬à¦¾à¦à¦²à¦¾',
  bs = 'Bosanski',
  bg = 'ÐÑÐ»Ð³Ð°ÑÑÐºÐ¸',
  ca = 'CatalÃ ',
  zh = 'ä¸­æ',
  zh_CN = 'Chinese (Simplified)',
  zh_HK = 'Chinese (Hong Kong)',
  zh_TW = 'Chinese (Traditional)',
  hr = 'Hrvatski',
  cs = 'CeskÃ½',
  da = 'Dansk',
  nl = 'Nederlands',
  en = 'English',
  en_AU = 'English (Australian)',
  en_GB = 'English (Great Britain)',
  et = 'Eesti',
  fa = 'â«ÙØ§Ø±Ø³Ûâ¬',
  fi = 'Suomi',
  fil = 'Filipino',
  fr = 'FranÃ§ais (France)â¬',
  fr_CA = 'French (Canada)',
  gl = 'Galego',
  ka = 'á¥áá áá£áá',
  de = 'Deutsch',
  el = 'ÎµÎ»Î»Î·Î½Î¹ÎºÎ¬',
  gu = 'Gujarati',
  iw = 'Hebrew',
  hi = 'Hindi',
  hu = 'Hungarian',
  is = 'Icelandic',
  id = 'Indonesian',
  it = 'Italian',
  ja = 'Japanese',
  kn = 'Kannada',
  kk = 'Kazakh',
  km = 'Khmer',
  ko = 'Korean',
  ky = 'Kyrgyz',
  lo = 'Lao',
  lv = 'Latvian',
  lt = 'Lithuanian',
  mk = 'Macedonian',
  ms = 'Malay',
  my = 'Malayalam',
  ml = 'Marathi',
  mr = 'Mongolian',
  mn = 'Burmese',
  ne = 'Nepali',
  no = 'Norwegian',
  pl = 'Polish',
  pt = 'Portuguese',
  pt_BR = 'Portuguese (Brazil)',
  pt_PT = 'Portuguese (Portugal)',
  pa = 'Punjabi',
  ro = 'Romanian',
  ru = 'Ð ÑÑÑÐºÐ¸Ð¹',
  sr = 'Serbian',
  siv = 'Sinhalese',
  sk = 'Slovak',
  sl = 'Slovenian',
  es = 'Spanish',
  es_419 = 'Spanish (Latin America)',
  sw = 'Swahili',
  sv = 'Swedish',
  ta = 'Tamil',
  te = 'Telugu',
  th = 'Thai',
  tr = 'TÃ¼rkÃ§e',
  uk = 'Ukrainian',
  ur = 'Urdu',
  uz = 'Uzbek',
  vi = 'Vietnamese',
  zu = 'Zulu',
}
